import { render, staticRenderFns } from "./Play_Order.vue?vue&type=template&id=5fd08851&scoped=true"
import script from "./Play_Order.vue?vue&type=script&lang=js"
export * from "./Play_Order.vue?vue&type=script&lang=js"
import style0 from "./Play_Order.vue?vue&type=style&index=0&id=5fd08851&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd08851",
  null
  
)

export default component.exports